import { Region } from 'utils/constants/location';
import { City } from 'utils/constants/location_legacy';
/** *
 * THIS IS A PLACE FOR BAD THINGS WE HAVE TO DO.
 * THE GOAL IS TO MAKE THIS FILE EMPTY.
 */

/** *
 * THIS IS A HARDCODED MAP OF THE CITY CODE TO REGION ID
 * The intent is to pile this hack onto the Company Group Config
 * until we can redo the whole Company Group Config.
 *
 * Ideally, the backend handles all city/region stuff and
 * the front-end submits city + region as two separate entities.
 */
export const CITY_TO_REGION_MAP: { [key in City]: Region } = {
  [City.TORONTO]: Region.CA_TORONTO,
  [City.CALGARY]: Region.CA_CALGARY,
  [City.VANCOUVER]: Region.CA_VANCOUVER,
  [City.EDMONTON]: Region.CA_EDMONTON,
  [City.AUSTIN]: Region.US_AUSTIN,
  [City.CORPUS_CHRISTI]: Region.US_SOUTH_TEXAS,
  // [City.ROUND_ROCK]: Region.US_AUSTIN,
  [City.PFLUGERVILLE]: Region.US_AUSTIN,
  [City.LOS_ANGELES]: Region.US_LOS_ANGELES,
  [City.SAN_ANTONIO]: Region.US_SAN_ANTONIO,
  [City.SAN_FRANCISCO]: Region.US_SAN_FRANCISCO,
  [City.HOUSTON]: Region.US_HOUSTON,
  [City.DALLAS]: Region.US_DALLAS_FORT_WORTH,
  [City.FORT_WORTH]: Region.US_DALLAS_FORT_WORTH,
  [City.JACKSONVILLE]: Region.US_JACKSONVILLE,
  [City.MIAMI]: Region.US_MIAMI,
  [City.ORLANDO]: Region.US_ORLANDO,
  [City.TAMPA]: Region.US_TAMPA,
  [City.INDIANAPOLIS]: Region.US_INDIANAPOLIS,
};

/**
 * THIS IS A REALLY BAD HACK!
 * A Region does NOT map to one City.  It is a 1 to many relationship.
 *
 * This will break when there are more than 1 City in a Region.
 */
export const REGION_TO_CITY_MAP: { [key in Region]: string } = {
  [Region.US_AUSTIN]: City.AUSTIN,
  [Region.US_SOUTH_TEXAS]: City.CORPUS_CHRISTI,
  [Region.US_DALLAS_FORT_WORTH]: City.DALLAS,
  [Region.US_SAN_ANTONIO]: City.SAN_ANTONIO,
  [Region.US_HOUSTON]: City.HOUSTON,
  [Region.US_SAN_FRANCISCO]: City.SAN_FRANCISCO,
  [Region.US_LOS_ANGELES]: City.LOS_ANGELES,
  [Region.US_JACKSONVILLE]: City.JACKSONVILLE,
  [Region.US_MIAMI]: City.MIAMI,
  [Region.US_ORLANDO]: City.ORLANDO,
  [Region.US_TAMPA]: City.TAMPA,
  [Region.US_INDIANAPOLIS]: City.INDIANAPOLIS,
  [Region.CA_TORONTO]: City.TORONTO,
  [Region.CA_VANCOUVER]: City.VANCOUVER,
  [Region.CA_EDMONTON]: City.EDMONTON,
  [Region.CA_CALGARY]: City.CALGARY,
};
